export default "__VITE_ASSET__Dg2CKj9W__"